import { RenderFunc } from 'KnmPackage/KnmHistoriesModule/types/RenderFunc';

const formatConfirmingMaterialNumber = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  return `Подтверждающий материал №${value}`;
};

export const renderConfirmingMaterialNumber: RenderFunc = item => ({
  renderedOldValue: formatConfirmingMaterialNumber(item.oldValue),
  renderedNewValue: formatConfirmingMaterialNumber(item.newValue),
});
